/* eslint-disable no-console, no-unused-vars */

import {
  CONTRACT_SERVICE,
  AVTALA_BACKEND,
  CONTACT_SERVICE
} from '../constants'

const CONTRACTS = "/contracts"

export const actions = {
  startAddContractSession ({ state, dispatch, commit }, { view }) {
    //const view = state.view?.id
    return dispatch('API', AVTALA_BACKEND, { root: true })
      .then(api => api.get('/contract/new?view=' + encodeURIComponent(view)))
      .then(response => {
        const data = response.data
        if(! state.newContract.currency) {
          // If currency is not set, it's not initialized yet.
          commit('setNewContract', data.values)
        }
        return data
      })
  },
  stopAddContractSession ({ dispatch, commit }) {
    return dispatch('API', AVTALA_BACKEND, { root: true })
      .then(api => api.delete('/contract/new'))
      .then(() => commit('clearNewContractData'))
  },
  setNewContractProperties ({ commit }, data) {
    commit('setNewContractProperties', data)
  },
  setNewContractMetadata ({ commit }, data) {
    commit('setNewContractMetadata', data)
  },
  setNewContractMetadataProperty ({ commit }, data) {
    commit('setNewContractMetadataProperty', data)
  },
  setNewContractView ({ commit }, v) {
    commit('setNewContractView', v)
  },
  setNewContractCategory ({ commit }, v) {
    commit('setNewContractCategory', v)
  },
  setNewContractType ({ commit }, v) {
    commit('setNewContractType', v)
  },
  setNewContractStatus ({ commit }, v) {
    commit('setNewContractStatus', v)
  },
  setNewContractParties ({ commit }, v) {
    commit('setNewContractParties', v)
  },
  addContact ({ commit }, value) {
    commit('addContact', value)
    return Promise.resolve(value)
  },
  addNewContractContact ({ commit }, contact) {
    commit('addContractContact', contact)
    return Promise.resolve(contact)
  },
  addNewChildContact ({ commit }, data) {
    commit('addChildContact', data)
    return Promise.resolve(data)
  },

  fetchContractMetadata ({ dispatch, getters }, view) {
    const metadata = {}
    return dispatch('fetchContractViews')
      .then(list => (metadata.views = list))
      .then(() => dispatch('fetchContractCategories'))
      .then(items => (metadata.categories = items.filter(v => v.view.id === view)))
      .then(() => dispatch('fetchContractTypes'))
      .then(items => (metadata.types = items.filter(v => v.view.id === view)))
      .then(() => dispatch('fetchContractStatuses'))
      .then(items => (metadata.statuses = items.filter(v => v.view.id === view)))
      .then(() => dispatch('getContractUserRoles'))
      .then(result => (metadata.roles = result.items))
      .then(() => dispatch('getContractTags', view))
      .then(result => (metadata.tags = result))
      .then(() => metadata)
  },

  getContractDetails ({dispatch }, id) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get('/contracts/' + encodeURIComponent(id) + '/metadata'))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  fetchContract ({ dispatch }, id) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get(CONTRACTS + '/' + encodeURIComponent(id)))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  fetchContractOverview ({ dispatch }, { view }) {
    return new Promise(function (resolve, reject) {
      const uri = ['/contract/overview']
      if(view) {
        uri.push('view=' + view)
      }
      dispatch('API', AVTALA_BACKEND, { root: true })
        .then(api => api.get(uri.join('?')))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  getContractTags ({ dispatch }, view) {
    return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get('/contracts/tags?view=' + encodeURIComponent(view)))
        .then(result => (result.data.items))
  },

  addContractTags ({ dispatch }, { id, tags }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.post('/contracts/' + encodeURIComponent(id) + '/tags', { tags }))
        .then(result => (result.data))
  },

  setContractStatus ({ dispatch }, { id, status }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.post('/contracts/' + encodeURIComponent(id) + '/status', { status }))
        .then(result => (result.data))
  },

  // TODO move to crm-contact plugin
  addContactTags ({ dispatch }, { id, tags }) {
    return dispatch('API', CONTACT_SERVICE, { root: true })
        .then(api => api.post('/' + encodeURIComponent(id) + '/tags', { tags }))
        .then(result => (result.data))
  },

  // GET
  //
  fetchContractViews ({ dispatch, commit, state }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true })
      .then(api => api.get('/views'))
      .then(result => {
        const views = result.data.items
        if(!state.view || !views.find(v => v.id === state.view.id)) {
          commit('setCurrentView', views.find(v => v))
        }
        return views
      })
  },

  fetchContractView ({ dispatch }, { id }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.get('/views/' + encodeURIComponent(id))).then(result => (result.data))
  },

  fetchContractCategories ({ dispatch }, view) {
    const query = view ? `?view=${encodeURIComponent(view)}` : '';
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.get('/categories' + query)).then(result => (result.data.items))
  },

  fetchContractCategory ({ dispatch }, { id }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.get('/categories/' + encodeURIComponent(id))).then(result => (result.data))
  },

  fetchContractTypes ({ dispatch }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.get('/types')).then(result => (result.data.items))
  },

  fetchContractStatuses ({ dispatch }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.get('/statuses')).then(result => (result.data.items))
  },

  fetchContractNotifications({ dispatch }, { id }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.get(CONTRACTS + '/' + encodeURIComponent(id) + '/notifications')).then(result => (result.data.items))
  },

  // POST (insert)
  //
  createContractView ({ dispatch }, data) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.post('/views', data)).then(result => (result.data))
  },

  createContractCategory ({ dispatch }, data) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.post('/categories', data)).then(result => (result.data))
  },

  createContractType ({ dispatch }, data) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.post('/types', data)).then(result => (result.data))
  },

  createContractStatus ({ dispatch }, data) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.post('/statuses', data)).then(result => (result.data))
  },

  // PUT (update)
  //
  updateContractView ({ dispatch, commit, state }, { id, data }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true })
      .then(api => api.put('/views/' + encodeURIComponent(id), data))
      .then(result => {
        const view = result.data
        if(state.view && state.view.id === view.id) {
          commit('setCurrentView', view)
        }
        return view
      })
  },

  updateContractCategory ({ dispatch }, { id, data }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.put('/categories/' + encodeURIComponent(id), data)).then(result => (result.data))
  },

  updateContractType ({ dispatch }, { id, data }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.put('/types/' + encodeURIComponent(id), data)).then(result => (result.data))
  },

  updateContractStatus ({ dispatch }, { id, data }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.put('/statuses/' + encodeURIComponent(id), data)).then(result => (result.data))
  },

  // DELETE
  //
  deleteContractView ({ dispatch }, id) {
    return dispatch('API', AVTALA_BACKEND, { root: true }).then(api => api.delete('/contract/views/' + encodeURIComponent(id))).then(result => (result.data))
  },

  deleteContractCategory ({ dispatch }, id) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.delete('/categories/' + encodeURIComponent(id))).then(result => (result.data))
  },

  deleteContractType ({ dispatch }, id) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.delete('/types/' + encodeURIComponent(id))).then(result => (result.data))
  },

  deleteContractStatus ({ dispatch }, id) {
    return dispatch('API', CONTRACT_SERVICE, { root: true }).then(api => api.delete('/statuses/' + encodeURIComponent(id))).then(result => (result.data))
  },

  setContractSearch({commit}, query) {
    commit('setContractSearch', query)
    return Promise.resolve(query)
  },

  searchContracts ({dispatch}, query) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, {root: true})
        .then(api => api.post(CONTRACTS + '/search?compact=true', query))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  selectContracts ({dispatch}, query) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, {root: true})
        .then(api => api.post(CONTRACTS + '/select', query))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  fetchContractsByContact ({ dispatch }, id) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get(CONTRACTS + '/contacts/' + encodeURIComponent(id)))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  fetchContractContacts ({ dispatch }, id) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get(CONTRACTS + '/' + encodeURIComponent(id) + '/contacts'))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  fetchContractSummary ({ dispatch }, id) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get(CONTRACTS + '/' + encodeURIComponent(id) + '/summary'))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  createContract ({ dispatch }, { contract }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.post(CONTRACTS + '/', contract))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  saveContract ({ dispatch }, { id, contract }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.post(CONTRACTS + '/' + encodeURIComponent(id), contract))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  deleteContract ({ dispatch }, { id }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
          .then(api => api.delete(CONTRACTS + '/' + encodeURIComponent(id)))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
    })
  },

  addContractContact ({ dispatch }, { id, contact }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.post(CONTRACTS + '/' + encodeURIComponent(id) + '/contacts', contact))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  addContractChildContact ({ dispatch }, { contract, parent, contact }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
          .then(api => api.post(CONTRACTS + '/' + encodeURIComponent(contract.id) + '/contacts/' + encodeURIComponent(parent.id), contact))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
    })
  },

  updateContractContact ({ dispatch }, { id, contact }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.put(CONTRACTS + '/' + encodeURIComponent(id) + '/contacts/' + encodeURIComponent(contact.id), contact))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  deleteContractContact ({ dispatch }, { id, contact }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.delete(CONTRACTS + '/' + encodeURIComponent(id) + '/contacts/' + encodeURIComponent(contact.id)))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  getContractUserRoles ({ dispatch }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get('/user-roles'))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  getContractUserRole ({ dispatch }, { id }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get('/user-roles/' + encodeURIComponent(id)))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  saveContractUserRole ({ dispatch }, role) {
    if(role.id) {
      return new Promise(function (resolve, reject) {
        dispatch('API', CONTRACT_SERVICE, { root: true })
          .then(api => api.put('/user-roles/' + encodeURIComponent(role.id), role))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
      })
    } else {
      return new Promise(function (resolve, reject) {
        dispatch('API', CONTRACT_SERVICE, { root: true })
          .then(api => api.post('/user-roles', role))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
      })
    }
  },

  deleteContractUserRole ({ dispatch }, { id }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.delete('/user-roles/' + encodeURIComponent(id)))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },

  saveContractUser ({ dispatch }, { id, user }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => {
          if(user.id) {
            return api.post(CONTRACTS + '/' + encodeURIComponent(id) + '/users/' + encodeURIComponent(user.id), user)
          } else {
            return api.post(CONTRACTS + '/' + encodeURIComponent(id) + '/users', user)
          }
        })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  deleteContractUser ({ dispatch }, { id, user }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.delete(CONTRACTS + '/' + encodeURIComponent(id) + '/users/' + encodeURIComponent(user.id)))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  saveContractPeriod ({ dispatch }, { id, period }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => {
          if(period.id) {
            return api.post(CONTRACTS + '/' + encodeURIComponent(id) + '/periods/' + encodeURIComponent(period.id), period)
          } else {
           return api.post(CONTRACTS + '/' + encodeURIComponent(id) + '/periods', period)
          }
        })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  deleteContractPeriod ({ dispatch }, { id, period }) {
    return new Promise(function (resolve, reject) {
      dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.delete(CONTRACTS + '/' + encodeURIComponent(id) + '/periods/' + encodeURIComponent(period.id)))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  setContractDetails ({ commit }, notification) {
    // Called by websocket/notification when backend finished analyzing text in uploaded file.
    const body = notification.body || {}
    commit('setContractDetails', body)
    return Promise.resolve(body)
  },
  exportContracts ({ dispatch }, request) {
    return new Promise(function (resolve, reject) {
      return dispatch('API', AVTALA_BACKEND, { root: true })
        .then(api => api.post('/contract/export', request))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  runWorkflows ({ dispatch }, { id }) {
    return dispatch('API', CONTRACT_SERVICE, { root: true })
      .then(api => api.post(CONTRACTS + '/' + encodeURIComponent(id) + '/workflows'))
      .then(result => (result.data))
  },
  globalSearch ({ dispatch }, query) {
    return new Promise(function (resolve, reject) {
      return dispatch('API', AVTALA_BACKEND, { root: true })
          .then(api => api.post('/contract/search', query))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
    })
  },
  searchContact({ dispatch }, query) {
    return new Promise(function (resolve, reject) {
      return dispatch('API', AVTALA_BACKEND, { root: true })
          .then(api => api.post('/contact/search', query))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
    })
  },
  bulkChangeUser({ dispatch }, payload) {
    return new Promise(function (resolve, reject) {
      return dispatch('API', CONTRACT_SERVICE, { root: true })
          .then(api => api.post('/contracts/update/user', payload))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
    })
  },
}
